import { Box, Checkbox, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { usePricing } from "../context/PricingContext";
import Utils from "../util/Utils";
import { breadCrumbStore, contractsStore } from "../state/CommonState";
import { enquiryStore } from "../enquiry/enquiry-data";
import { useSnapshot } from "valtio";
import { groupedByCategory, PRICING_CATEGORY } from "../charges_data/LCLCharges";

function checkForCharges(charge,rec){
    let isValidCharge = true;
     if((charge.chargeDescription === "Pick-up Charges" && charge.total ===0) || (charge.chargeDescription.includes("Delivery Charges") && charge.total ===0) || (rec?.fba==="Yes" && charge.chargeDescription === "Destination Customs Clearance") || rec?.mode==="CONTRACT" || (rec?.mode === "QUOTE" && !charge?.isIncluded) ){
        isValidCharge = false;
     }
    return isValidCharge;
}

let enabledCharges = [
    'Origin Customs Clearance',
    'Destination Customs Clearance',
    'Pick-up Charges',
    'Delivery Charges'
]
 
 function SelectableCharges({charge,backgroundColor}){
    console.log(" the chatges came here is ",charge.chargeDescription);
    const [value,setValue] = useState(charge?.isIncluded==="Yes");
    const {changeCharges,disableInclusion,isInidaDoor,rec} = usePricing();
    const [checkForInValidCharge,setValidCharge] = useState(true);
    
    useEffect(()=>{
        if(rec){
            setValidCharge(checkForCharges(charge,rec));  
        }
    },[rec])

    return <div className={`flex flex-row justify-between w-full py-[7px] items-center px-[17px] ${backgroundColor}`}>
  <span style={{display:"flex",flexDirection:"row",gap:0.6,alignItems:"center"}}>
   {checkForInValidCharge  && <Checkbox  iconStyle={{fill: process.env.REACT_APP_ENTERPRISE_COLOUR}} disabled={disableInclusion} checked={value} onChange={(e)=>{
        setValue(e.target.checked);
        changeCharges(e.target.checked,charge.chargeDescription)  
    }} sx={{padding:0}} size="small"/>}
    <p className="text-[15px] text-[#1F1F1F]" >{charge.chargeDescription}</p></span>
    <p className="text-[15px] text-[#1F1F1F]" >{charge.isDiscount && charge.volumeDiscount > 0 ? Utils.N(charge.total-charge.volumeDiscount)  : charge.total == 0 ? "Charges Awaited" : Utils.N(charge.total,charge.currency)}</p>
   </div>
}
function ChargesTable({ title, charges, total }) {
  const groupedCharges = groupedByCategory(charges);

  return (
    <div className="flex flex-col w-full mb-4">
      {Object.entries(groupedCharges).map(([category, charges]) => (
        <div key={category}>
          {/* <div className="w-full px-[17px] py-[6px] bg-[#EAF4FB] text-[#1E4E79] font-bold text-[14px]">
            {PRICING_CATEGORY[category]?.label || title}
          </div> */}

          {charges.map((chargeDetail, i) => (
            <div
              key={chargeDetail.id || i}
              className={`flex flex-row justify-between w-full py-[8px] items-center px-[17px] ${
                i % 2 === 0 ? "bg-white" : "bg-[#F3F3F3]"
              }`}
            >
              <p className="text-[15px] text-[#1F1F1F]">
                {chargeDetail.chargeDescription}
              </p>
              <p className="text-[15px] text-[#1F1F1F]">
                {Utils.N(chargeDetail.total, chargeDetail.currency)}
              </p>
            </div>
          ))}
        </div>
      ))}

      { total && <div className="flex flex-row justify-between w-full h-[35px] items-center px-[18px] bg-[#F3F3F3] font-bold">
        <p>{"Total Cost"}</p>
        <p>{Utils.N(total)}</p>
      </div>}
    </div>
  );
}


export default function PriceDetails({ charge, pkb = [], rebate = [] }) {
  useSnapshot(breadCrumbStore);

  return (
    <div className="flex flex-col w-full gap-6">
      <ChargesTable
        title="Charges"
        charges={charge.charges}
        total={charge.total}
      />

      {/* {rebate.length > 0 && (
        <ChargesTable
          title="Rebate"
          charges={rebate}
        />
      )}

      {pkb.length > 0 && (
        <ChargesTable
          title="Freight Commission"
          charges={pkb}
        />
      )} */}

    </div>
  );
}



export function PricingDetailsCard2({title = "Price Details",isAccordionView=false,charge, pkb=[], rebate=[]}){
    const {rec,setShowShipperPDA} = usePricing();  
    useEffect(()=>{
      if(rec){
         if(rec?.shipmentType?.includes("FCL") && rec?.oih && charge?.account?.includes('Your')){
            setShowShipperPDA((prev)=>({...prev,include:true}));
         }
      }
    },[rec]) 
    return <div className="flex flex-col w-full">
          { !isAccordionView && <div className="flex flex-row justify-between w-full h-[35px] items-center px-[18px] bg-blue-dark">
            <p className="text-sm text-[white] font-bold">{title}</p>
            {/* <p className="text-sm text-[white] font-bold">Price in INR</p> */}
           </div>}
           <PriceDetails charge={charge} pkb={pkb} rebate={rebate}/>
    </div>
}